import { forwardRef, type Ref, type SVGProps } from "react";

function SvgExit(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg ref={ref} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
      <path
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M9.667 2.333h2a2 2 0 0 1 2 2v7.334a2 2 0 0 1-2 2h-2M10.333 8h-8m8 0L8 10.333M10.333 8 8 5.667"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgExit);
export default ForwardRef;
